import { IRefreshTokenResponse, IUserLogin } from 'src/@types/User'
import { createSession, refreshTokenRequest } from 'src/services/config'

export async function createUserSession(username: string, senha: string): Promise<IUserLogin> {
  return createSession(username, senha)
}

export async function refreshSession(refreshToken: string): Promise<IRefreshTokenResponse> {
  return refreshTokenRequest(refreshToken)
}

export async function destroySession(): Promise<void> {
  return Promise.resolve()
}
